export const requiredFields = ['year', 'country', 'countryShortCode', 'holidayDate', 'holidayName'];
